<template>
    <div class="nav-bar"
    :class="{active : menuOpen}"
    >
        
        <!-- :class="{active:menuOpen}" -->
         <h5><router-link to="/" class="nav-link"> Home </router-link></h5> 
           <h5><router-link to="/leather" class="nav-link"> Leather </router-link></h5> 
             <h5><router-link to="/about" class="nav-link">About Us </router-link></h5>
            <h5><router-link to="/contact" class="nav-link">Contact Us </router-link></h5>
            <router-link to="/cart" class="cart-link"> Your Cart </router-link>
    </div>
</template>

<script>
export default {
  name: 'NavBar',
  data() {
    return {
      menuOpen: false
    }
  }
}
</script>

<style scoped>
h5{
    color: black;
}

.line{
    width: 100%; border: 2px solid black;
}

.nav-bar {
  display: grid;
  grid-template-columns: auto auto auto auto 1fr auto;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  padding: 15px 5%;
  gap: 25px;
  background-color: #333;
}

.nav-bar h5 {
  margin: 0;
}

.nav-bar .nav-link{
    margin-left: 55px;
    margin-right: 55px;
    color: whitesmoke;
}

.nav-bar  .nav-link:hover{
    color: #b65f4a !important;
}

.cart-link {
  background-color: #c76b4a;
  color: white !important;
  padding: 8px 16px;
  border-radius: 5px;
  text-decoration: none;
  font-weight: 600;
  white-space: nowrap;
  text-align: center;
}

.cart-link:hover {
  background-color: #f3a281;
  color: white !important;
}

@media (max-width: 768px) {

  .nav-bar {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
    padding: 15px;
    width: 100%;
    box-sizing: border-box;
  } 

  .nav-bar h5 {
    margin: 0;
  }

  .nav-link {
    font-size: 16px;
     left: -260px;
  }

  .cart-link {
    margin-left: 0;
    margin-top: 5px;
    padding: 8px 15px;
  }

}

@media (max-width: 480px) {

  .nav-bar {
    gap: 12px;
    padding: 12px 10px;
  }

  .nav-link {
    font-size: 15px;
  }

  .cart-link {
    font-size: 14px;
    padding: 7px 13px;
  }

}



</style>

